import React, { useEffect } from 'react';
import { useAppDispatch, useTypedSelector } from 'store/index';
import { fetchApplicationById } from 'store/application';
import { showAppAuth } from 'components/auth';
import UserContainer from 'components/user-container';
import './index.scss';

const OAuth: React.FC = () => {
  const { user } = useTypedSelector((state) => state.user);
  const dispatch = useAppDispatch();
  const params = new URLSearchParams(location.search);
  const clientId = params.get('client_id');

  useEffect(() => {
    if (clientId) {
      dispatch(fetchApplicationById(clientId));
    }
    /* eslint-disable-next-line react-hooks/exhaustive-deps*/
  }, [clientId]);

  if (user && clientId) {
    const url = decodeURIComponent(params.get('redirect_uri') || '');
    showAppAuth(clientId, { mask: false }, url, false);
  }

  return (
    <div className="oauth-page">
      <UserContainer toggle />
    </div>
  );
};

export default OAuth;
